<template>
  <div class="drop-menu">
    <div class="drop-menu-list">
      <div
        v-for="(item, index) in menuTitles"
        :key="index"
        :class="[
          'drop-menu-list-item',
          item.active ? 'active' : '',
          item.selected ? 'selected' : '',
          item.disabled ? 'disabled' : '',
        ]"
        @click="toggleItem(index, item.disabled)"
      >
        <span class="title">{{ item.title }}</span>
        <span class="icon-dropdown"></span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import getRect from '@/utils/get-rect.js';
export default {
  data() {
    return {
      menus: [],
      offset: {
        top: 0,
        bottom: 0,
      },
    };
  },
  provide() {
    return {
      rootDropMenu: this,
    };
  },
  computed: {
    menuTitles() {
      return this.menus.map(item => {
        return {
          title: item.selectedText,
          active: item.isPopupShow,
          selected: item.value !== '',
          disabled: item.disabled,
        };
      });
    },
  },
  methods: {
    $_addMenu(menu) {
      if (this.menus.indexOf(menu) === -1) {
        this.menus.push(menu);
      }
    },
    $_removeMenu(menu) {
      const index = this.menus.indexOf(menu);
      if (index >= 0) {
        this.menus.splice(index, 1);
      }
    },
    toggleItem(active, disabled = false) {
      if (disabled) return;
      this.menus.forEach((item, index) => {
        if (index === active) {
          this.updateOffset();
          item.toggle();
        } else {
          item.toggle(false, { immediate: true });
        }
      });
    },
    updateOffset() {
      if (this.$el) {
        const rect = getRect(this.$el);
        this.offset.top = rect.top;
        this.offset.bottom = rect.bottom;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.drop-menu-list {
  display: flex;
  box-sizing: border-box;
  padding: 0 2.13vw;
  height: 11.73vw;
  background: #fff;

  .drop-menu-list-item {
    flex: 1 0 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
      margin-right: 1.07vw;
      word-ellipsis();
    }

    .icon-dropdown {
      width: 0;
      height: 0;
      border: 1.07vw solid transparent;
      border-top-color: #bcc7cb;
      border-bottom: none;
      transform: rotateZ(0deg);
      transition: transform 0.2s linear;
    }

    &.active {
      color: color-primary;

      .icon-dropdown {
        border-top-color: color-primary;
        transform: rotateZ(-180deg);
      }
    }

    &.selected {
      color: color-primary;

      .icon-dropdown {
        border-top-color: color-primary;
      }
    }

    &.disabled {
      opacity: 0.6;
    }
  }
}
</style>
